import axios from 'axios'

export default {
    getAll: () => axios.get(`/page`),
    getBySlug: slug => axios.get(`/page/${slug}`),
    edit: formData => axios.put(`/page/edit`, formData),
    changeStatus: formData => axios.patch(`page/toggle_status`, formData)
}
